// @packages
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from '@material-ui/core/styles';

// @scripts
import FanWizardItem from './fan-wizard-item';
import { config } from '../../config';
import { globalUI } from '../../core';

// @styles
import styles from './styles';

const CategoryPage = ({ classes, id }) => (
    <Paper id={id} className={classes.fanItem} elevation={0}>
        <Grid container spacing={2}>
            {config.fanSizerSubmenu.map((submenuItem, index) => (
                <Grid key={index} item xs={12} sm={6} md={4} lg={4}>
                    <FanWizardItem
                        description={submenuItem.description}
                        id="fan-wizard-item"
                        imageSource={globalUI.getImage(`./${submenuItem.name}.png`)}
                        title={submenuItem.title}
                        url={submenuItem.url}
                    />
                </Grid>
            ))}
        </Grid>
    </Paper>
);

CategoryPage.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired
};

export default withStyles(styles)(CategoryPage);
